import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IPaginationItem {
  meta: { page: number; limit: number };
  items: any[];
}

interface ITemplateListState {
  templateList: any[];
  templatePagination: IPaginationItem[];
  isReset: boolean,
}

const initialState: ITemplateListState = {
  templateList: [],
  templatePagination: [],
  isReset: false,
};

const templateListSlice = createSlice({
  name: "templateList",
  initialState,
  reducers: {
    setTemplateList: (state, action: PayloadAction<any>) => {
      state.templateList = action.payload;
    },
    setTemplatePagination: (state, action: PayloadAction<any>) => {
      state.templatePagination = action.payload;
    },
    setTemplateIsReset: (state, action: PayloadAction<any>) => {
      state.isReset = action.payload;
    },
    clearTemplateList: (state) => {
      state.templateList = [];
      state.templatePagination = [];
      state.isReset = false;
    },
  },
});

export const {
  setTemplateList,
  setTemplatePagination,
  setTemplateIsReset,
  clearTemplateList,
} = templateListSlice.actions;
export const TemplateListReducer = templateListSlice.reducer;
